import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyB0dPhUC44xv_byhi5o0aRN3GagyYQpB_o",

  authDomain: "ptu-db.firebaseapp.com",

  projectId: "ptu-db",

  storageBucket: "ptu-db.firebasestorage.app",

  messagingSenderId: "690192216408",

  appId: "1:690192216408:web:e71bfb087611ec7792b52d",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export const googleProvider = new GoogleAuthProvider();
export { auth, db, storage };
